import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import FinalFeature from '@features/final';
import { useFormStore } from '@store/use-form-store';

function VisitorFinalPage() {
  const navigate = useNavigate();
  const { resetProcess } = useFormStore();

  const handleReset = () => {
    resetProcess();
    navigate(ROUTES.VR_WELCOME);
  };

  return <FinalFeature isVisitorRegistration={true} onReset={handleReset} />;
}

export default VisitorFinalPage;
